import React, { useEffect } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import HowItWorks from "@/components/HowItWorks";

export default function ServicesPage() {
    useEffect(() => {
        window.scrollTo(0, 0);
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("in");
                        obs.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12 }
        );
        document.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
        return () => obs.disconnect();
    }, []);

    return (
        <main data-testid="services-page" className="relative bg-[var(--paper)]">
            <Nav />
            <header className="pt-32 md:pt-40 pb-12 md:pb-16 border-b border-line">
                <div className="maxw section-pad">
                    <div className="eyebrow mb-5">Services</div>
                    <h1 className="font-display font-light text-5xl sm:text-6xl md:text-7xl leading-[0.98] tracking-tight max-w-4xl">
                        Lawn, garden &amp; outdoor work —{" "}
                        <span className="italic text-[var(--terra)]">
                            handled neat
                        </span>
                        .
                    </h1>
                    <p className="mt-6 max-w-2xl text-[rgba(14,14,16,0.68)] text-base md:text-lg leading-relaxed">
                        Eight core services, one small crew. Mix and match
                        anything below — we’ll quote it fairly and finish it
                        properly.
                    </p>
                </div>
            </header>
            <Services />
            <WhyChooseUs />
            <HowItWorks />
            <Footer />
        </main>
    );
}
